/**
 * Client-side SLA clock helpers for Support tickets.
 */

export function slaRemainingMs(sla, nowMs = Date.now()) {
  if (!sla?.enabled || !sla.due_at) return null;
  if (sla.frozen && sla.frozen_at) {
    return Date.parse(sla.due_at) - Date.parse(sla.frozen_at);
  }
  return Date.parse(sla.due_at) - nowMs;
}

/** Format remaining_ms as clock string; negative shows as -H:MM:SS or -Nd … */
export function formatSlaClock(remainingMs, { compact = false } = {}) {
  if (remainingMs == null || !Number.isFinite(remainingMs)) return '—';
  const overdue = remainingMs < 0;
  let ms = Math.abs(remainingMs);
  const days = Math.floor(ms / (24 * 60 * 60 * 1000));
  ms -= days * 24 * 60 * 60 * 1000;
  const hours = Math.floor(ms / (60 * 60 * 1000));
  ms -= hours * 60 * 60 * 1000;
  const minutes = Math.floor(ms / (60 * 1000));
  ms -= minutes * 60 * 1000;
  const seconds = Math.floor(ms / 1000);

  const pad = (n) => String(n).padStart(2, '0');
  let body;
  if (compact) {
    if (days > 0) body = `${days}d ${hours}h`;
    else if (hours > 0) body = `${hours}h ${pad(minutes)}m`;
    else body = `${minutes}m ${pad(seconds)}s`;
  } else if (days > 0) {
    body = `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  } else {
    body = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
  return overdue ? `-${body}` : body;
}
